// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//Services
import { CASNavBoxService } from '../../shared/components/cas-navbox/cas-navbox-service';
import { CPDFormatters } from '../../shared/services/cpd-formatters';
import { WebServices } from '../../shared/services/webServices';
import { Helpers } from '../../shared/services/helpers';
import { FormAction } from '../../shared/classes/formAction';

//Libraries
import { BCGrowls } from '../../shared/library/bcGrowls';

//Config/Globals
import { Enums } from '../../shared/enums.js';

//Auth & Config
import { authToken } from '../../shared/authToken';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
@Component({
    template : '<div class="ppv-main-div" data-test-id="content_purposes_view">\n\n    <!--Title-->\n    <!--<div tabindex="0" class="nar-title-div"><h2>{{_title}}</h2></div>-->\n    <h2 tabindex="-1" class="ppv-title-div">{{_title}}</h2>\n\n    <div style="margin:0 10px 15px 20px; font-style:italic">Select a purpose to manage.</div>\n    <div style="height:10px;"></div>\n\n    <!--Content Loading -->\n    <ng-template #loading>\n        <div class="ppv-ui-content-loading">\n            <img src="public/cpd-images/loading.gif" />\n            <div style="margin-left:10px;">Loading...</div>\n        </div>\n    </ng-template>\n\n    <!--Selected Asset Display-->\n    <div *ngIf="!_isLoading()" class="ppv-ui-cell">\n        <div class="ppv-ui-group-lbl" role="heading" aria-label="Asset"><h3>Asset</h3></div>\n        <div style="margin:10px 0 5px 10px;">\n            <span style="font-weight:bold;margin-right:5px;">Asset Code:</span><span>{{_selectedAsset?.practice_code}}</span>\n            <span style="font-weight:bold;margin:0 5px 0 20px;">Asset Name:</span><span>{{_selectedAsset?.practice_name}}</span>\n        </div>\n    </div>\n\n\n    <!--Content Div -->\n    <div *ngIf="!_isLoading(); else loading" class="ppv-ui-row" style="flex-grow:1;">\n        <!--<div *ngIf="!_isLoading(); else loading" class="ppv-ui-cell" style="flex-grow:1;">\n        <div class="ppv-ui-group-lbl" role="heading" aria-label="Purposes"><h3>Purposes</h3></div>-->\n        <!-- Purposes Grid --------------------------------->\n        <cas-grid #purposesGrid\n                  summary="Purposes List"\n                  [settings]="purposesGridSettings"\n                  (onRefreshClicked)="onGridRefreshClicked()"\n                  (onRowSelectionChanged)="onRowSelectionChanged()"\n                  (onPageChanged)="onPageChanged($event)">\n        </cas-grid>\n\n        <!--Popups-->\n        <!--====================================================================================================-->\n        <!--POPUP INSTANCE CONTAINER-->\n        <!--When the Modal component inserts the Angular component that wraps the Bootstrap popups, it needs to go somewhere\n    where it will be cleared when the user navigates away from this page.  Note that the popup elements inserted here\n    are moved to the \'body\' when displayed and then moved back here when not (so the heat shield/backdrop is under them in z-order).-->\n        <div id="purposes_view_page_popups"></div>\n\n        <!--====================-->\n        <!-- Add Purpose -->\n        <!--====================-->\n        <modal #popAddPurpose\n               containerId="purposes_view_page_popups"\n               title="Add Purpose"\n               label="popAddPurpose">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_purpose_view_add_purpose"></section>\n\n            <!-- body -->\n            <section>\n\n                <form #addPurposeForm="ngForm">\n\n                    <div class="form-group">\n                        <label for="add_purpose_name" style="font-weight:bold; color:dimgray">Purpose Name</label>\n                        <textarea #add_purpose_name="ngModel"\n                                  id="add_purpose_name"\n                                  name="add_purpose_name"\n                                  class="form-control"\n                                  rows="4"\n                                  type="text"\n                                  style="flex-grow:1"\n                                  aria-label="Purpose Name"\n                                  maxlength="250"\n                                  [(ngModel)]="_newPurposeName">\n                    </textarea>\n                    </div>\n                    <div *ngIf="add_purpose_name.dirty || add_purpose_name.touched">\n                        <div *ngIf="!newPurposeNameValid()" class="alert alert-danger">\n                            Purpose name is required.\n                        </div>\n                    </div>\n\n                    <div class="row">\n                        <div class="col-6">\n                            <div class="form-group">\n                                <label for="add_start_date_selector" style="font-weight:bold; color:dimgray">Start Date</label>\n                                <input #add_start_date_selector="ngModel"\n                                       type="date"\n                                       id="add_start_date_selector"\n                                       name="add_start_date_selector"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       class="form-control"\n                                       [(ngModel)]="_newStartDate" />\n                            </div>\n                            <div *ngIf="add_start_date_selector.dirty || add_start_date_selector.touched">\n                                <div *ngIf="!newPurposeStartDateValid()" class="alert alert-danger">\n                                    Start date is required.\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class="col-6">\n                            <div class="form-group">\n                                <label for="add_end_date_selector" style="font-weight:bold; color:dimgray">End Date</label>\n                                <input type="date"\n                                       id="add_end_date_selector"\n                                       name="add_end_date_selector"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       class="form-control"\n                                       [(ngModel)]="_newEndDate" />\n                            </div>\n                        </div>\n                    </div>\n\n                    <div style="display:flex; align-items:center">\n                        <input type="checkbox"\n                               id="add_publish"\n                               name="add_publish"\n                               [(ngModel)]="_newPublish" />\n                        <label for="add_publish" style="font-weight:bold; color:dimgray">&nbsp;Publish</label>\n                    </div>\n\n                </form>\n\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button id="add_cancel" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n                <button id="add_save" accesskey="s" type="button" class="btn btn-primary" (click)="addPurpose()"><u>S</u>ave</button>\n                <!--<button id="add_save" type="submit" class="btn btn-primary">Save</button>-->\n                <!--data-dismiss="modal"-->\n            </footer>\n        </modal>\n\n        <!--====================-->\n        <!-- Edit Purpose -->\n        <!--====================-->\n        <modal #popEditPurpose\n               containerId="purposes_view_page_popups"\n               title="Edit Purpose"\n               label="popEditPurpose">\n\n            <!--FVT-ID-->\n            <section name="fvt_id" style="visibility:hidden;" data-test-id="dialog_purpose_view_edit_purpose"></section>\n\n            <!-- body -->\n            <section>\n\n                <form #editPurposeForm="ngForm">\n\n                    <div class="form-group">\n                        <label for="edit_purpose_name" style="font-weight:bold; color:dimgray">Purpose Name</label>\n                        <textarea #edit_purpose_name="ngModel"\n                                  id="edit_purpose_name"\n                                  name="edit_purpose_name"\n                                  class="form-control"\n                                  rows="4"\n                                  type="text"\n                                  style="flex-grow:1"\n                                  aria-label="Purpose Name"\n                                  maxlength="250"\n                                  [(ngModel)]="_editPurposeName">\n                    </textarea>\n                    </div>\n                    <div *ngIf="edit_purpose_name.dirty || edit_purpose_name.touched">\n                        <div *ngIf="!editPurposeNameValid()" class="alert alert-danger">\n                            Purpose name is required.\n                        </div>\n                    </div>\n\n                    <div class="row">\n                        <div class="col-6">\n                            <div class="form-group">\n                                <label for="edit_start_date_selector" style="font-weight:bold; color:dimgray">Start Date</label>\n                                <input #edit_start_date_selector="ngModel"\n                                       type="date"\n                                       id="edit_start_date_selector"\n                                       name="edit_start_date_selector"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       aria-label="Start date (format m/d/yyyy)"\n                                       class="form-control"\n                                       [(ngModel)]="_editStartDate" />\n                            </div>\n                            <div *ngIf="edit_start_date_selector.dirty || edit_start_date_selector.touched">\n                                <div *ngIf="!editPurposeStartDateValid()" class="alert alert-danger">\n                                    Start date is required.\n                                </div>\n                            </div>\n\n                        </div>\n                        <div class="col-6">\n                            <div class="form-group">\n                                <label for="edit_end_date_selector" style="font-weight:bold; color:dimgray">End Date</label>\n                                <input #edit_end_date_selector="ngModel"\n                                       type="date"\n                                       id="edit_end_date_selector"\n                                       name="edit_end_date_selector"\n                                       [min]="_today"\n                                       placeholder="m/d/yyyy"\n                                       aria-label="End date (format m/d/yyyy)"\n                                       class="form-control"\n                                       [(ngModel)]="_editEndDate" />\n                            </div>\n                        </div>\n                    </div>\n\n                    <div style="display:flex; align-items:center">\n                        <input #edit_publish="ngModel"\n                               type="checkbox"\n                               *ngIf="!_isPublished"\n                               id="edit_publish"\n                               name="edit_publish"\n                               [(ngModel)]="_editPublish" />\n                        <input type="checkbox"\n                               aria-disabled="true"\n                               *ngIf="_isPublished"\n                               id="edit_publish"\n                               name="edit_publish"\n                               onclick="return false"\n                               role="application"\n                               aria-label="Publish checkbox"\n                               [(ngModel)]="_editPublish" />\n                        <label for="edit_publish" style="font-weight:bold; color:dimgray">&nbsp;Publish</label>\n                    </div>\n\n                </form>\n\n            </section>\n\n            <!-- footer -->\n            <footer>\n                <button id="edit_cancel" type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>\n                <button id="edit_save" accesskey="s" type="button" class="btn btn-primary" (click)="editPurpose()"><u>S</u>ave</button>\n            </footer>\n        </modal>\n\n\n    </div>\n\n\n    </div>\n\n\n\n\n\n\n\n',
    styles : ['.ppv-main-div{display:flex;flex-direction:column;position:absolute;top:0px;right:0px;bottom:0px;left:0px}.ppv-ui-row{position:relative;margin:15px 0 0 0;border-top:solid 1px #ccc}.ppv-ui-cell{position:relative;background-color:#f0f0f0;border-radius:4px;border:solid 1px #b8b8b8;padding:10px 15px 10px 15px;margin:0 10px}.ppv-ui-group-lbl{position:absolute;top:-8px;left:5px;background-color:#d4e2f2;border-radius:4px;border:solid 1px #b8b8b8;padding:1px 8px;box-shadow:1px 1px 5px rgba(0,0,0,0.3)}.ppv-ui-content-loading{display:flex;font-style:italic;margin:10px 20px}.ppv-title-div{margin:10px 8px 15px 8px;padding-bottom:4px;border-bottom:solid 1px #b8b8b8}'],
    providers: []
})
export class PurposesViewComponent {

    // INPUTS/OUTPUTS/COMPONENTS
    //-------------------------------------------------------------------------------------------------------------------------
    @ViewChild('purposesGrid') purposesGrid;
    @ViewChild('popAddPurpose') popAddPurpose;
    @ViewChild('popEditPurpose') popEditPurpose;

    @ViewChild('addPurposeForm') addPurposeForm;
    @ViewChild('editPurposeForm') editPurposeForm;

	//Class wide member reference for the growls control
	growlBox = null;


    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    // Boiler Plater
    _allFieldsDisabled = false;
    _componentName = 'purposesView.js';
    _disposalFunctions = [];
    _formName = "purposes_view";
    _loading = true;
    _sessionStorageObject = null;
    _title = "";

    //BL
    _selectedAsset = null;
    _selectedPurpose = null;
    _today = new Date().toISOString().substring(0, 10);
    _newPurposeName = "";
    _editPurposeName = "";
    _newStartDate = null;
    _editStartDate = null;
    _newEndDate = null;
    _editEndDate = null;
    _newPublish = false;
    _editPublish = false;
    _isPublished = false;
    _purposeForEdit = null;

    //Grid settings
    purposesGridSettings = {
        rowsPerPage : 20,
        hideClearSelectedButton: true,
        hideSearchBox: true,
        rowIdentifyForJAWS: true,
        rowIdentityFieldForJAWS: "practice_purpose_name",
        rowIdentityPrefixForJAWS: "Purpose Name",
        showCheckboxColumn: true,
        positionAbsolute: true,

        columns: [
            { fieldName: 'practice_purpose_name', display: 'Name', width: '60%', minWidth: 200 },
            { fieldName: 'start_date', display: 'Start Date', width: '11%', minWidth: 75, procDataFn: this._formatDate.bind(this), dataType: 'date' },
            { fieldName: 'end_date', display: 'End Date', width: '11%', minWidth: 75, procDataFn: this._formatDate.bind(this), dataType: 'date'  },
            { fieldName: 'publish', display: 'Published', width: '11%', minWidth: 75 }
        ],
        rows: []
    }

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    //_boundKeypressHandler = null;


    // INITIALIZATION/LIFECYCLE
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(
        casNavBoxService: CASNavBoxService,
        cpdFormatters: CPDFormatters,
        helpers: Helpers,
        route: ActivatedRoute,
        router: Router,
        webServices: WebServices) {

        this.constructor.mapParams(this, arguments);

        //Init page
        this._markPageAsLoading(true);

        //Init local storage
        this._sessionStorageObject = this._loadSessionStorageObject();
        if (!this._sessionStorageObject) {

            this._sessionStorageObject = {
                selectedPurposeId: null,
                currentPage: 1
            }
            this._saveSessionStorageObject(this._sessionStorageObject);
        }

        //Handle nav menu events
        this._disposalFunctions.push(casNavBoxService.OnActionClicked$.subscribe(action => {
            this.NavBoxActionClicked(action);
        }));

        //Add title
        this._title = "View Purposes";


        // Debugging
        //-------------------------------------------
        casNavBoxService.ClearDebugEntries();
        casNavBoxService.DebugEntries.push("Dump Local Storage");
        let disposer = casNavBoxService.OnDebugEntryClicked$.subscribe(entry => {
            this._debugEntryClicked(entry);
        });
        this._disposalFunctions.push(disposer);

        //Keypress Handler
        //-------------------------------------------
        //Prebind the listener (not using this here, keep for later)
        //this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        //No longer necessary
        //window.addEventListener("keyup", this._boundKeypressHandler);
    }

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy() {
        this._disposalFunctions.map(x => x.unsubscribe());
        //window.removeEventListener("keyup", this._boundKeypressHandler);
    }

    //==================================
    // ngOnInit
    //==================================
    ngOnInit() {
        this.set508();
        this.initalizeGrowlBox();
        this.performAsyncOperations();
        this.setNavBoxActions();
    };

    //==================================
    // ngOnInit_Complete
    //==================================
    ngOnInit_Complete() {
        //this.LoadPurposes(() => {
        //    this._markPageAsLoading(false);
        //});
        this.LoadPurposes(); 
        this._markPageAsLoading(false);
        
    }

    
    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // set508
    //==================================
    set508() {
        window.setTimeout(() => {
            document.getElementById("accAlertAssertive").innerText = "Loading page data";

            let el = document.getElementsByClassName("ppv-title-div")[0];
            if (el) { el.focus(); }
        }, 0);
    }

    //==================================
    // initalizeGrowlBox
    //==================================
    initalizeGrowlBox() {
        this.growlBox = new BCGrowls("growlBox");
        this.growlBox.init({
            appendToElementId: "cpdesGrowlContainer" //cpdesGrowlContainer defined in \Nrcs.Cpdes.Ui\src\cpdes\components\cpdes.html
        });
    };

    //==================================
    // performAsyncOperations
    //==================================
    performAsyncOperations() {
        //Number of async ops this function has left to complete
        var ops = 1;

        // PARAMS
        //(note that this is a snapshot and will not change without a page reload)
        //(use rxjs if you need to react to changes. Ex: https://kamranahmed.info/blog/2018/02/28/dealing-with-route-params-in-angular-5/)
        var selectedAssetId = this.route.snapshot.params.practiceId;

        //Load the practice for the indicated practiceId
        this.webServices.Get({
            apiPath: "/practices/getPractice",
            args: { practiceId: selectedAssetId }
        })
            .then(res => {

                console.log(`[${this._componentName}:_loadData():/practices/getPractice] - res: `, res);

                if (res.data.Success) {
                    this._selectedAsset = res.data.DTO;
                    this._selectedAsset.practiceStateId = this.route.snapshot.params.practiceStateId;
                    //Done?
                    if (--ops == 0) { this.ngOnInit_Complete(); }
                }
                else {
                    this.growlBox.addGrowl("error", "Failed to load asset.");
                    console.log(this.cpdFormatters.formatError(res.data.ErrorMessage));
                }
            })
            .catch(err => {
                this.growlBox.addGrowl("error", "Failed to load asset.");
                console.log(this.cpdFormatters.formatError(err));
            });
    }

    //==================================
    // setNavBoxActions
    //==================================
    setNavBoxActions() {
        let actions = [];

        switch (authToken.user.role) {

            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                actions.push(new FormAction("act_add_purpose", "Add Purpose"));
                actions.push(new FormAction("act_edit_purpose", "Edit Purpose"));
                break;

            default:
                break;
        }


        //Tell the shared navBoxCommService what the current actions are (will update the navBox actions)
        this.casNavBoxService.Actions = actions;
        this.casNavBoxService.ActionsLoading = false;
    }

    //==================================
    // LoadPurposes
    //==================================
    LoadPurposes(fnOnComplete) {

        this._markGridAsLoading(true);

        //Load the purposes for the selected asset
        this.webServices.Get({
            apiPath: "/purpose/getPurposeList",
            args: {
                assetCode: this._selectedAsset.practice_code
            }
        })
            .then((res) => {
                console.log(`[${this._componentName}:LoadPurposes():/purpose/getPurposeList] res: `, res);
                this._setGridRows(res.data.DTO);
                this._markGridAsLoading(false);
                this._sortGrid("practice_purpose_name", "A");
                if (fnOnComplete) { fnOnComplete(); }
            })
            .catch((err) => {
                this.growlBox.addGrowl("error", "Failed to load purposes.");
                console.log(this.cpdFormatters.formatError(err));
                this._markGridAsLoading(false);
                if (fnOnComplete) { fnOnComplete(); }
            });
        
    }

    //=======================================
    // sendJawsNotification
    //=======================================
    sendJawsNotification(message) {
        $("#accLivePolite").empty();
        $("#accLivePolite").append(`<p>${message}</p>`);
    }

    // UI HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // addPurpose()
    //==================================
    addPurpose() {

        if (this.validateNewPurpose()) {

            //Close the popup            
            this.popAddPurpose.Close();

            //Do the deed
            this.createPurpose();
        }

        //No need to do anything here, as this popup has an angular form, and it will show the users validation issues
    }

    //==================================
    // validateNewPurpose()
    //==================================
    validateNewPurpose() {

        //Force the Angular form to run validation on each control
        this.helpers.markAngularFormDirty(this.addPurposeForm.form);

        //Let caller know if we are good to proceed        
        return (this.newPurposeNameValid() && this.newPurposeStartDateValid());
    }

    //==================================
    // createPurpose()
    //==================================
    createPurpose() {

        this._disableUI();
        this.growlBox.addGrowl("info", "Saving new purpose...");
        let purposeForSave = this._prepPurposeForSave();
        
        this.webServices.Post("/purposes/createPurpose", purposeForSave)
            .then((response) => {
                this.executeValidResponseActionsCreate(response);
            })
            .catch((err) => {
                this.growlBox.addGrowl("error", "An error occured while saving.");
                console.log(this.cpdFormatters.formatError(err));
            });

        document.getElementById('cpd_content_div').scrollTop = 0;
        this._enableUI();
    }

    //==================================
    // _executeValidResponseActionsCreate
    //==================================
    executeValidResponseActionsCreate(response) {
        console.log("[purposesView: createPurpose() - response:]", response);
        if (response.Success) {
            this.executeSuccessActionsCreate();
        }
        else {
            this.executeErrorActionsCreate(response);
        }
    }

    //==================================
    // _executeSuccessActionsCreate
    //==================================
    executeSuccessActionsCreate() {
        this.growlBox.addGrowl("success", "Purpose created.");
        this.refreshPage();
    }

    //==================================
    // refreshPage
    //==================================
    refreshPage() {
        this._newPublish = null;
        this._newStartDate = null;
        this._newEndDate = null;
        this._newPurposeName = null;
        this._editPublish = null;
        this._editStartDate = null;
        this._editEndDate = null;
        this._editPurposeName = null;
        this.LoadPurposes();
    }

    //==================================
    // _executeErrorActionsCreate
    //==================================
    executeErrorActionsCreate(response) {
        if (response.ValidationErrors.length > 0) {
            this.growlBox.addGrowl("error", `There were validation errors on purpose create.`);
            console.log(this.cpdFormatters.formatValidationErrors(response.ValidationErrors));
        }
        else {
            this.growlBox.addGrowl("error", `An error occured while creating purpose.`);
            console.log(this.cpdFormatters.formatError(response));
        }
    }

    //==================================
    // editPurpose()
    //==================================
    editPurpose() {


        if (this.validateEditPurpose()) {

            //Close the popup            
            this.popEditPurpose.Close();

            //Do the deed
            this.updatePurpose();
        }

        //No need to do anything here, as this popup has an angular form, and it will show the users validation issues
    }

    //==================================
    // validateEditPurpose()
    //==================================
    validateEditPurpose() {

        //Force the Angular form to run validation on each control
        this.helpers.markAngularFormDirty(this.editPurposeForm.form);

        //If no changes are made, then just close the popup as we interpret this to mean no changes are needed
        if (!this.editChangesMade()) {
            //this.growlBox.addGrowl("info", "No changes detected");
            this.popEditPurpose.Close();
            return false;
        }

        //Let caller know if we are good to proceed        
        return (this.editPurposeNameValid() && this.editPurposeStartDateValid());
    }

    //==================================
    // editChangesMade()
    //==================================
    editChangesMade() {
        return this._editPurposeName != this._purposeForEdit.practice_purpose_name
            || (this._editStartDate ? new Date(this._editStartDate).toISOString().substring(0, 19) : null) != this._purposeForEdit.start_date
            || (this._editEndDate ? new Date(this._editEndDate).toISOString().substring(0, 19) : null) != this._purposeForEdit.end_date
            || (this._editPublish ? "Y" : "N") != this._purposeForEdit.publish;
    }

    //==================================
    // updatePurpose
    //==================================
    updatePurpose() {
        this._disableUI();
        this.growlBox.addGrowl("info", "Editing purpose...");

        let purposeForEdit = this._prepPurposeForEdit();
        
        this.webServices.Post("/purposes/updatePurpose", purposeForEdit)
            .then((response) => {
                this.executeUpdatePurposeValidResponseActions(response);
            })
            .catch((err) => {
                this.growlBox.addGrowl("error", `An error occured while updating purpose.`);
                console.log(this.cpdFormatters.formatError(err));
            });
        document.getElementById('cpd_content_div').scrollTop = 0;
        this._enableUI();
    }

    //==================================
    // executeUpdatePurposeValidResponseActions
    //==================================
    executeUpdatePurposeValidResponseActions(response) {
        console.log("[purposesView:_updatePurpose() - response:]", response);
        if (response.Success) {
            this.executeUpdatePurposeSuccessActions();
        }
        else {
            this.executeUpdatePurposeErrorActions(response);
        }
    }

    //==================================
    // executeUpdatePurposeSuccessActions
    //==================================
    executeUpdatePurposeSuccessActions() {
        this.growlBox.addGrowl("success", "Purpose Edited.");
        this.refreshPage();
    }

    //==================================
    // executeUpdatePurposeErrorActions
    //==================================
    executeUpdatePurposeErrorActions(response) {
        if (response.ValidationErrors.length > 0) {
            this.growlBox.addGrowl("error", `There were validation errors while updating the purpose.`);
            console.log(this.cpdFormatters.formatValidationErrors(response.ValidationErrors));
        }
        else {
            this.growlBox.addGrowl("error", `An error occured while updating the purpose.`);
            console.log(this.cpdFormatters.formatError(response));
        }
    }

    //==================================
    // NavBoxActionClicked
    //==================================
    NavBoxActionClicked(action) {

        switch (action.field_name) {

            case "act_add_purpose":

                this.popAddPurpose.Open();

                break;

            case "act_edit_purpose":
                //Make sure a purpose has been selected
                if (!this._selectedPurpose) {
                    this.growlBox.addGrowl("info", "No row selected");
                    return;
                }
                this.loadPurposeForEdit();

                break;

        }
    }

    //==================================
    // loadPurposeForEdit
    //==================================
    loadPurposeForEdit() {
        this._disableUI();
        let purposeId = this._selectedPurpose.practice_purpose_id;
        this.webServices.Get({
            apiPath: "/purposes/getPurposeById",
            args: { purposeId: purposeId }
        })
            .then(res => {
                this._loadPurposeValidResponseActions(res.data);
            })
            .catch(err => {
                this.growlBox.addGrowl("error", `An error occured while loading the purpose for edit`);
                console.log(this.cpdFormatters.formatError(err));
            });
        this._enableUI();
    }

    //=====================================
    // _loadPurposeValidResponseActions
    //=====================================
    _loadPurposeValidResponseActions(res) {
        if (res.Success) {
            console.log("[purposeEdit:_loadPurpose() - response:]", res);
            this._setWorkingPurpose(res.DTO);
            this.popEditPurpose.Open();
        }
        else {
            this._loadPurposeErrorActions(res);
        }
    }

    //==================================
    // _setWorkingPurpose
    //==================================
    _setWorkingPurpose(purpose) {
        this._purposeForEdit = purpose;
        this._editPurposeName = purpose.practice_purpose_name;
        this._editStartDate = purpose.start_date ? new Date(purpose.start_date).toISOString().substring(0, 10) : null;
        this._editEndDate = purpose.end_date ? new Date(purpose.end_date).toISOString().substring(0, 10) : null;
        this._editPublish = (purpose.publish && purpose.publish.toUpperCase() == 'Y') ? true : false;

        this._isPublished = (purpose.publish && purpose.publish.toUpperCase() == 'Y') ? true : false;
    }

    //==================================
    // _loadPurposeErrorActions
    //==================================
    _loadPurposeErrorActions(res) {
        if (res.ValidationErrors.length > 0) {
            this.growlBox.addGrowl("error", `There were validation errors while loading the purpose.`);
            console.log(this.cpdFormatters.formatValidationErrors(res.ValidationErrors));
        }
        else {
            this.growlBox.addGrowl("error", `An error occured while loading purpose.`);
            console.log(this.cpdFormatters.formatError(res));
        }
    }

    //==================================
    // onGridRefreshClicked
    //==================================
    onGridRefreshClicked() {
        this.LoadPurposes();
    };

    //==================================
    // onPageChanged
    //==================================
    // $event will contain the new page
    onPageChanged($event) {

        var newPage = $event;

        //Store the new page in the local storage
        this._sessionStorageObject.currentPage = newPage;
        this._saveSessionStorageObject(this._sessionStorageObject);
    }

    //==================================
    // onRowSelectionChanged
    //==================================
    onRowSelectionChanged() {

        if (this.purposesGrid) {
            this._selectedPurpose = this.purposesGrid.GetFirstSelectedRow();

            if (this._selectedPurpose) {
                this._sessionStorageObject.selectedPurposeId = this._selectedPurpose.practice_purpose_id;
                this._saveSessionStorageObject(this._sessionStorageObject);
                console.log(`Selected Purpose: `, this._selectedPurpose);
            }
            else {
                this._sessionStorageObject._selectedPurposeId = null;
                this._saveSessionStorageObject(this._sessionStorageObject);
            }
        }
    }

    //==================================
    // newPurposeNameValid
    //==================================
    newPurposeNameValid() {
        return this._newPurposeName != null && this._newPurposeName != '';
    }

    //==================================
    // newPurposeStartDateValid
    //==================================
    newPurposeStartDateValid() {
        return this._newStartDate != null && this._newStartDate != '';
    }

    //==================================
    // editPurposeNameValid
    //==================================
    editPurposeNameValid() {
        return this._editPurposeName != null && this._editPurposeName != '';
    }

    //==================================
    // editPurposeStartDateValid
    //==================================
    editPurposeStartDateValid() {
        return this._editStartDate != null && this._editStartDate != '';
    }

    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _disableUI
    //==================================
    _disableUI() {
        this.casNavBoxService.DisableAllLinks();
        this._allFieldsDisabled = true;
    };

    //==================================
    // _enableUI
    //==================================
    _enableUI() {
        this.casNavBoxService.EnableAllLinks();
        this._allFieldsDisabled = false;
    };

    //==================================
    // _formatDate
    //==================================
    _formatDate(dateString) {
        return this.cpdFormatters.formatDateString(dateString);
    };

    //==================================
    // _isLoading
    //==================================
    _isLoading() {
        return this._loading || this.casNavBoxService.ActionsLoading;
    }

    //==================================
    // _loadSessionStorageObject
    //==================================
    _loadSessionStorageObject() {
        var obj = sessionStorage.getItem(this._formName);
        return obj ? JSON.parse(obj) : null;
    }

    //==================================
    // _markGridAsLoading
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _markGridAsLoading(isLoading) {

        if (this.purposesGrid) {
            this.purposesGrid.MarkAsLoading(isLoading);
        }
        else {
            this.purposesGridSettings.loading = isLoading;
        }
    }

    //==================================
    // _markPageAsLoading
    //==================================
    _markPageAsLoading(isLoading) {
        this._loading = isLoading;
    }

    //==================================
    // _saveSessionStorageObject
    //==================================
    _saveSessionStorageObject(obj) {
        if (!obj) { throw "[{0}:_saveSessionStorageObject] - obj must not be empty".format(this._componentName) }
        sessionStorage.setItem(this._formName, JSON.stringify(obj));
    }

    //==================================
    // _setGridRows
    //==================================
    // The grid is not always fully loaded when we want to interact with it,
    // so here well test and see if we need to change the underlying settings
    // or the loaded object.
    _setGridRows(data) {

        if (this.purposesGrid) {
            this.purposesGrid.SetRows(data);
        }
        else {
            this.purposesGridSettings.rows = data;
        }
    }

    //==================================
    // _sortGrid
    //==================================
    _sortGrid(column, direction) {

        // Let's give the grid a chance to render for a bit and then sort
        // once it comes up.  Keep it tight though, or we'll sort too long
        // after the grid comes up.
        this.helpers.executeOnCondition(
            () => { return !!this.purposesGrid; },
            () => { this.purposesGrid.SortGrid(column, direction); },
            50, 10
        );

    }

    //==================================
    // _prepPurposeForSave
    //==================================
    _prepPurposeForSave() {
        let purposeForSave = {};
        purposeForSave.publish = this._newPublish ? 'Y' : 'N';
        purposeForSave.start_date = this._newStartDate ? new Date(this._newStartDate).toISOString() : null;
        purposeForSave.end_date = this._newEndDate ? new Date(this._newEndDate).toISOString() : null;
        purposeForSave.practice_purpose_name = this._newPurposeName;
        purposeForSave.practice_state_id = this._selectedAsset.practiceStateId;
        return purposeForSave;
    }

    //==================================
    // _prepPurposeForEdit
    //==================================
    _prepPurposeForEdit() {
        let purposeForEdit = {};
        purposeForEdit.practice_purpose_id = this._selectedPurpose.practice_purpose_id
        purposeForEdit.publish = this._editPublish ? 'Y' : 'N';
        purposeForEdit.start_date = this._editStartDate ? new Date(this._editStartDate).toISOString() : null;
        purposeForEdit.end_date = this._editEndDate ? new Date(this._editEndDate).toISOString() : null;
        purposeForEdit.practice_purpose_name = this._editPurposeName;
        purposeForEdit.practice_state_id = this._selectedAsset.practiceStateId;
        return purposeForEdit;
    }

    // DEBUGGING
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _debugEntryClicked
    //==================================
    _debugEntryClicked(entry) {
        console.log("[purposes:_debugEntryClicked]");
        console.log("    ", entry);

        switch (entry) {
            case "Dump Local Storage":
                console.log(this._sessionStorageObject);
        }
    };

}

